import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { CourseApiServiceService } from '../../../pages/courses/course-api-service.service';
import { Store } from '@ngrx/store';
import { courseDetails, courseId, coursePrice } from '../../../pages/courses/store/course.selector';
import { setCoursePrice } from '../../../pages/courses/store/course.action';
import { ToasterService } from '../../../providers/toaster/toaster.service';
@Component({
  selector: 'app-pricing-section',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './pricing-section.component.html',
  styleUrl: './pricing-section.component.css'
})
export class PricingSectionComponent {

  pricingForm!: FormGroup
  courseId: any;
  isSubmitted = false;
  constructor(private fb: FormBuilder, private cousrseApiService: CourseApiServiceService, private store: Store, private toasterService: ToasterService) {
    this.store.select(courseId).subscribe((res) => {
      this.courseId = res
      
    }
    )
  }


  ngOnInit() {
    this.pricingForm = this.fb.group({
      pricing: this.fb.array([
        this.fb.group({
          price_type: ['internal'],
          gross_total: ['', [Validators.required, Validators.pattern(/^[0-9]{1,7}$/), Validators.min(1), Validators.max(9999999)]],
          discount_type: ['%', [Validators.required]],
          discount: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
          final_price: [''],
          total_off: [''],
        }, { validators: [this.discountGroupValidator()] }),
        this.fb.group({
          price_type: ['external'],
          gross_total: ['', [Validators.required, Validators.pattern(/^[0-9]{1,7}$/), Validators.min(1), Validators.max(9999999)]],
          discount_type: ['%', [Validators.required]],
          discount: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
          final_price: [''],
          total_off: [''],
        }, { validators: [this.discountGroupValidator()] })
      ], { validators: [this.atLeastOnePriceValidator()] })
    })
    this.store.select(coursePrice).subscribe((res) => {
      if (res) {        
        this.pathchFormValue(res);
      }
    })
  }

  pathchFormValue(data:any) {
    const priceArray = this.pricingForm.get('pricing') as FormArray;
      console.log(data);
    
    data.forEach((item: any) => {
      
      if (item.price_type == 'internal') {
        priceArray.at(0).patchValue({
          gross_total: item.gross_total || 0,
          discount_type: item.discount_type,
          discount: item.discount || 0,
          final_price: item.final_price || 0,
        });
      } else if (item.price_type == 'external') {
        priceArray.at(1).patchValue({
          gross_total: item.gross_total || 0,
          discount_type: item.discount_type,
          discount: item.discount || 0,
          final_price: item.final_price || 0,
        });
      }
    })
    this.calculateFinalPrice(0);
    this.calculateFinalPrice(1);
  }


  ngAfterViewInit(): void {
  const pricingArray = this.pricingForm.get('pricing') as FormArray;

  pricingArray.controls.forEach((group, index) => {
    group.valueChanges.subscribe(() => {
      this.calculateFinalPrice(index);
    });
  });
}



  get pricingFormArray() {
    return this.pricingForm.get('pricing') as FormArray;
  }

  onGrossTotalInput(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    const digitsOnly = input.value.replace(/\D+/g, '');
    if (digitsOnly !== input.value) {
      input.value = digitsOnly;
      const control = (this.pricingForm.get('pricing') as FormArray).at(index).get('gross_total');
      control?.setValue(digitsOnly, { emitEvent: false });
    }
  }

  savePrice() {
    this.isSubmitted = true;
    if (this.pricingForm.invalid) {
      this.pricingForm.markAllAsTouched();
      this.pricingForm.get('pricing')?.markAsTouched();
      this.toasterService.setToaster('error', 'Error', 'Please fill all required pricing fields correctly');
      return;
    }

    let value = this.pricingForm.value;
    const pricing = Array.isArray(value?.pricing) ? value.pricing : [];
    const filteredPricing = pricing.filter((item: any) => {
      const grossNum = parseFloat(item?.gross_total ?? '');
      const finalNum = parseFloat(item?.final_price ?? '');
      return (Number.isFinite(grossNum) && grossNum > 0) || (Number.isFinite(finalNum) && finalNum > 0);
    });
    this.cousrseApiService.setCoursePrice(filteredPricing, this.courseId).subscribe({
      next: (res: any) => {
        if (res.status == 'success') {
          this.store.dispatch(setCoursePrice({ data: res.data }));
          this.toasterService.setToaster('success', 'Success', res.message || 'Pricing updated successfully');
        } else {
          this.toasterService.setToaster('error', 'Error', res.message || 'Failed to update pricing');
        }
      },
      error: (err: any) => {
        console.error('HTTP error:', err);
        this.toasterService.setToaster('error', 'Error', err?.message || 'Something went wrong while updating pricing');
      }
    })
  }


  private discountGroupValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const group = control as FormGroup;
      const discountType = group.get('discount_type')?.value;
      const grossValue = group.get('gross_total')?.value;
      const discountValue = group.get('discount')?.value;
      const errors: ValidationErrors = {};

      const grossNum = parseFloat(grossValue);
      const discountNum = parseInt(discountValue, 10);

      if (!discountValue && discountValue !== 0) {
        errors['discountRequired'] = true;
      } else if (!/^[0-9]+$/.test(discountValue)) {
        errors['discountPattern'] = true;
      } else if (discountType === '%') {
        if (discountNum < 0 || discountNum > 100) {
          errors['discountPercentageRange'] = true;
        }
      } else if (discountType === '$') {
        if (discountNum < 0) {
          errors['discountNegative'] = true;
        }
        if (Number.isFinite(grossNum) && discountNum > grossNum) {
          errors['discountExceedsGross'] = true;
        }
      }

      return Object.keys(errors).length ? errors : null;
    };
  }

  private atLeastOnePriceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const array = control as FormArray;
      if (!array?.controls?.length) {
        return { priceRequired: true };
      }
      const hasPrice = array.controls.some((group) => {
        const gross = group.get('gross_total')?.value;
        const final = group.get('final_price')?.value;
        const grossNum = parseFloat(gross);
        const finalNum = parseFloat(final);
        return (Number.isFinite(grossNum) && grossNum > 0) || (Number.isFinite(finalNum) && finalNum > 0);
      });
      return hasPrice ? null : { priceRequired: true };
    };
  }

  calculateFinalPrice(index: number): void {
  const pricingArray = this.pricingForm.get('pricing') as FormArray;
  const group = pricingArray.at(index) as FormGroup;

  const grossTotal = parseFloat(group.get('gross_total')?.value || '0');
  const discountType = group.get('discount_type')?.value;
  const discount = parseFloat(group.get('discount')?.value !== "" ? group.get('discount')?.value : '0');

  let totalOff = 0;
  let finalPrice = grossTotal;

  if (discountType === '%') {
    totalOff = (grossTotal * discount) / 100;
  } else if (discountType === '$') {
    totalOff = discount;
  }

  finalPrice = grossTotal - totalOff;

  group.patchValue({
    final_price: finalPrice >= 0 ? finalPrice.toFixed(2) : '0.00',
    total_off: totalOff >= 0 ? totalOff.toFixed(2) : '0.00',
  }, { emitEvent: false });
}




}
